const BlankSpace = () => {
    return (
        <span className="blank-space d-inline-flex align-items-center">
            ---           
        </span>
    )
}

export default BlankSpace
